import { has, isEmpty } from "lodash";
import alertify from "alertifyjs";
import "./Notification.css";
import "alertifyjs/build/css/alertify.min.css";
import "alertifyjs/build/css/themes/default.min.css";
import Translate from "helpers/Translate";

function Notify() {
  return {
    success: (content, { position = "bottom-center", forceDelay = 4 } = {}) => {
      if (!content) return;
      alertify.set("notifier", "position", position);
      alertify.set("notifier", "delay", forceDelay);

      let notification = alertify.success(content),
        delay = alertify.get("notifier", "delay"),
        timer;

      if (delay) {
        notification.element.addEventListener("mouseover", function () {
          notification.delay(delay);
          timer = setInterval(function () {
            notification.delay(delay);
          }, 1000 * delay - 500);
        });
        notification.element.addEventListener("mouseout", function () {
          clearInterval(timer);
        });
      }

      return notification;
    },
    info: (content, { position = "bottom-center", forceDelay = 4 } = {}) => {
      if (!content) return;
      alertify.set("notifier", "position", position);
      alertify.set("notifier", "delay", forceDelay);

      let notification = alertify.notify(content, "custom"),
        delay = alertify.get("notifier", "delay"),
        timer;

      if (delay) {
        notification.element.addEventListener("mouseover", function () {
          notification.delay(delay);
          timer = setInterval(function () {
            notification.delay(delay);
          }, 1000 * delay - 500);
        });
        notification.element.addEventListener("mouseout", function () {
          clearInterval(timer);
        });
      }

      return notification;
    },
    warning: (content, { position = "bottom-center", forceDelay = 4 } = {}) => {
      if (!content) return;
      alertify.set("notifier", "position", position);
      alertify.set("notifier", "delay", forceDelay);

      let notification = alertify.warning(content),
        delay = alertify.get("notifier", "delay"),
        timer;

      if (delay) {
        notification.element.addEventListener("mouseover", function () {
          notification.delay(delay);
          timer = setInterval(function () {
            notification.delay(delay);
          }, 1000 * delay - 500);
        });
        notification.element.addEventListener("mouseout", function () {
          clearInterval(timer);
        });
      }

      return notification;
    },
    error: (content, { position = "bottom-center", forceDelay = 4 } = {}) => {
      if (!content) return;
      alertify.set("notifier", "position", position);
      alertify.set("notifier", "delay", forceDelay);

      let notification = alertify.error(content),
        delay = alertify.get("notifier", "delay"),
        timer;

      if (delay) {
        notification.element.addEventListener("mouseover", function () {
          notification.delay(delay);
          timer = setInterval(function () {
            notification.delay(delay);
          }, 1000 * delay - 500);
        });
        notification.element.addEventListener("mouseout", function () {
          clearInterval(timer);
        });
      }

      return notification;
    },
    confirm: (
      content,
      {
        title = Translate({ id: "confirmation_required" }),
        labelOk = Translate({ id: "delete", uppercase: true }),
        labelCancel = Translate({ id: "cancel", uppercase: true }),
        onOk = () => {},
        onCancel = () => {}
      } = {}
    ) => {
      alertify
        .confirm(title, content, onOk, onCancel)
        .set("labels", { ok: labelOk, cancel: labelCancel });
    },
    alert: (
      content,
      {
        title = Translate({ id: "notification" }),
        labelOk = Translate({ id: "ok", uppercase: true }),
        onOk = () => {}
      } = {}
    ) => {
      alertify.alert(title, content, onOk).set("label", labelOk);
    }
  };
}

const Notification = new Notify();
export default Notification;

export const notifyApiError = error => {
  if (
    has(error, "response.data.data.errors") &&
    error.response.data.data.errors.length > 0
  ) {
    let message = "";
    for (const itetator of error.response.data.data.errors) {
      message += `<li>- ${itetator.message}</li>`;
    }
    Notification.error(`<ul className="error">${message}</ul>`);
  } else if (has(error, "message") && !isEmpty(error.message)) {
    Notification.error(error.message);
  }
};
